import React from "react";
import {Affix, Button, message, Popconfirm, Spin} from "antd";
import Draggable from "react-draggable";
import {Resizable} from "re-resizable";
import {CheckOutlined, CloseOutlined, CloseSquareOutlined, DeleteOutlined} from '@ant-design/icons/lib';

import ReactPanZoom from "react-image-pan-zoom-rotate";
import {LoadingOutlined} from "@ant-design/icons";

import {MSG_APPROVE_SUCCESS, MSG_REJECT_SUCCESS} from "../../../util/Messages";
import TextArea from "antd/es/input/TextArea";
import {FileProperty} from "./FileProperty";
import documentService from "../../../service/documentService";



const TOP = 100;
const WIDTH = 700;
const HEIGHT = 450;
const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;


interface Prop {
    fileProperty: FileProperty;
    removeDocumentWindow?: (documentTypeId: any) => void;
    removeOrDeleteDocumentWindow?: (documentTypeId: any, isDeleteDoc: boolean) => void;
    refreshDocumentStatus?: (documentTypeId: any, documentStatus: string) => void;
}

export class DocumentViewer extends React.Component<Prop, any> {

    constructor(prop: Prop) {
        super(prop);
        let _zIndex: any = sessionStorage.getItem("zIndex") ? sessionStorage.getItem("zIndex") : 1000000;
        let zIndex = parseInt(_zIndex) + 1;
        this.state = {
            x: 0,
            y: 60,
            zIndex: zIndex,
            top: TOP, width: WIDTH, height: HEIGHT, hideButton: false, style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "solid 1px #ddd",
                background: "#f0f0f0",
                zIndex: zIndex,
                rejectReason: "",
                rejectReasonStatus: ""
            }
        }
        sessionStorage.setItem("zIndex", zIndex + "");
    }

    componentDidMount() {
        window.addEventListener('scroll', this.listenToScroll);

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.listenToScroll)
    }

    listenToScroll = () => {
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop

        const height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight

        const scrolled = (winScroll / height) * 100;
        console.log("scrolled", scrolled)
        this.setState({
            top: scrolled,
        })
    }

    deleteDocument = () => {
      /*  if (this.props.removeDocumentWindow && this.props.forwardedDocumentViewCompRef) {
            let documentViewComp: MainLocalVideoView | null = this.props.forwardedDocumentViewCompRef.current;
            documentViewComp?.onDelete(this.props.fileProperty.documentId);
            this.props.removeDocumentWindow(this.props.fileProperty.documentId);
        }

        if (this.props.removeOrDeleteDocumentWindow) {
            this.props.removeOrDeleteDocumentWindow(this.props.fileProperty.documentId, true);
        }*/
    }

    updateStatus = (documentStatus: string) => {
        let data: any;
        if (documentStatus == "REJECTED") {
            if (!this.state.rejectReason || this.state.rejectReason == "") {
                this.setState({rejectReasonStatus: "error"});
                message.error("Please enter reject reason");
                return;
            }
            data = documentService
                .updateApproveDocumentStatus({
                    uploadDocumentDetailId: this.props.fileProperty.documentId,
                    documentStatus: documentStatus,
                    remark: this.state.rejectReason
                });
        } else {
            this.setState({rejectReason: ""});
            data = documentService
                .updateApproveDocumentStatus({
                    uploadDocumentDetailId: this.props.fileProperty.documentId,
                    documentStatus: documentStatus,
                    remark: this.state.rejectReason
                });
        }
        data
            .then((res: any) => {
                if (200 == res.status || 201 == res.status) {
                    if (documentStatus == "CHECKED") {
                        message.success(MSG_APPROVE_SUCCESS);
                       /* let isUndertakeDocumentType = res.data.undertakeDocumentType;
                        if (this.props.forwardedDocumentViewCompRef && isUndertakeDocumentType) {
                            let documentViewComp: MainLocalVideoView | null = this.props.forwardedDocumentViewCompRef.current;
                            documentViewComp?.setInitAllDocument();
                        }*/
                    } else if (documentStatus == "REJECTED") {
                        message.success(MSG_REJECT_SUCCESS);
                    }
                    this.setState({hideButton: true})
                    /*if (this.props.forwardedDocumentViewCompRef) {
                        let documentViewComp: MainLocalVideoView | null = this.props.forwardedDocumentViewCompRef.current;
                        documentViewComp?.refreshDocumentStatus(this.props.fileProperty, documentStatus);
                    }*/

                    if (this.props.refreshDocumentStatus) {
                        this.props.refreshDocumentStatus(this.props.fileProperty, documentStatus);
                    }
                } else {
                    message.error("Can not be Updated");
                    this.setState({hideButton: false})
                    return
                }
            }, (reason: any) => {
                this.setState({hideButton: false});
                message.error("Can not be Updated");
            });
    }

    onFocusWindow = () => {
        let _zIndex: any = sessionStorage.getItem("zIndex") ? sessionStorage.getItem("zIndex") : 9999;
        let zIndex = parseInt(_zIndex) + 1;
        let style = {...this.state.style}

        style.zIndex = zIndex
        this.setState({style: style});
        sessionStorage.setItem("zIndex", zIndex + "");
    }

    onChangeRejectReason = (e: any) => {
        this.setState({rejectReason: e.target.value, rejectReasonStatus: ""})
    }

    render() {
        const {x, y} = this.state;
        return <div style={{display: "flex", justifyContent: "flex-start"}} onClick={event => {
            // this.onFocusWindow()
        }}>
            <Affix style={this.props.removeOrDeleteDocumentWindow ? {
                position: 'absolute',
                top: -79.1,
                right: -118
            } : {position: 'absolute', top: 10}}
                   onChange={(affixed:any) => console.log("Affixed", affixed)}>
                <Draggable handle="strong" bounds="body" onDrag={(e, data) => {
                    this.setState({x: data.x});
                    if (data.y < 60) {
                        this.setState({y: 60});
                    } else {
                        this.setState({y: data.y});
                    }
                }} defaultPosition={{x: x, y: y}} position={{x: x, y: y}} onMouseDown={e => this.onFocusWindow()}>
                    <Resizable
                        style={this.state.style}
                        defaultSize={{
                            width: WIDTH + 20,
                            height: HEIGHT + 50,
                        }}
                        onResizeStop={(event: any, direction: any, refToElement: any, delta) => {
                            let state = {...this.state}
                            let width = state.width + delta.width;
                            let height = state.height + delta.height;
                            this.setState({width: width, height: height});
                        }}
                        className='drag-doc-view'
                    >

                        <div className={this.props.fileProperty.documentStatus == "CHECKED" ? "box no-cursor cls-check"
                            : this.props.fileProperty.documentStatus == "REJECTED" ? "box no-cursor cls-reject" : "box no-cursor cls-uploaded"}
                             style={{
                                 display: 'flex', flexDirection: 'column', padding: '0px 10px 10px 10px',
                                 boxShadow: '0px 0px 12px 2px #ccc'
                             }}

                        >
                            <strong className="cursor"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        cursor: "move"
                                    }}>
                                <div style={{
                                    cursor: "move",
                                    padding: '10px 0'
                                }}>{this.props.fileProperty.windowTitle}</div>
                                <CloseSquareOutlined
                                    // onClick={event => this.props.removeDocumentWindow(this.props.fileProperty.documentId)}
                                    onClick={() => {
                                        if (this.props.removeOrDeleteDocumentWindow) {
                                            this.props.removeOrDeleteDocumentWindow(this.props.fileProperty.documentId, false);
                                        }
                                        if (this.props.removeDocumentWindow) {
                                            this.props.removeDocumentWindow(this.props.fileProperty.documentId)
                                        }
                                    }}
                                    style={{fontSize: 18, cursor: 'pointer', color: '#ffffff'}}/>
                            </strong>
                            <div style={{height: `${this.state.height}px`, width: `${this.state.width}px`}}>
                                <div style={{
                                    whiteSpace: 'pre-wrap',
                                    height: `${this.state.height}px`,
                                    width: `${this.state.width}px`,
                                }}>

                                    {
                                        this.props.fileProperty.fileType == 'PDF' ?
                                            <iframe src={this.props.fileProperty.file} title="testPdf"
                                                    height="100%" width="100%"/> :
                                            <>
                                                <div style={{
                                                    height: "100%",
                                                    textAlign: "center",
                                                    paddingLeft: 20,
                                                    paddingTop: 20,
                                                    paddingBottom: 20,
                                                    backgroundColor: "lightgray",
                                                    overflow: 'auto'
                                                }}>
                                                    <Spin spinning={this.props.fileProperty.isLoading}
                                                          indicator={antIcon}
                                                          style={{backgroundColor: "lightgray"}}>
                                                        <div
                                                            style={{
                                                                height: 400,
                                                                width: 600,
                                                                backgroundColor: "lightgray"
                                                            }}>
                                                            <ReactPanZoom
                                                                image={this.props.fileProperty.file}
                                                                alt={this.props.fileProperty.windowTitle}
                                                            />
                                                        </div>
                                                    </Spin>
                                                </div>
                                            </>
                                    }

                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginTop: 16,
                                        position: 'absolute',
                                        bottom: '24px',
                                        right: '32px'
                                    }}>
                                        {

                                            this.props.fileProperty.documentStatus == "PENDING" && this.state.hideButton == false ? (<>
                                                <Button type="primary" className='approve-btn'
                                                        style={{marginRight: 16}}
                                                        icon={
                                                            <CheckOutlined/>}
                                                        onClick={(event:any) => this.updateStatus('CHECKED')}
                                                >
                                                    Approve
                                                </Button>
                                                <TextArea status={this.state.rejectReasonStatus} style={{width: 280, marginRight: 16}}
                                                          rows={1} onChange={this.onChangeRejectReason}/>
                                                <Button type="primary" danger style={{marginRight: 16}}
                                                        className='reject-btn'
                                                        icon={<CloseOutlined/>}
                                                        onClick={(event:any) => this.updateStatus("REJECTED")}
                                                >
                                                    Reject
                                                </Button></>) : (<></>)
                                        }
                                        {
                                            this.props.fileProperty.documentStatus != "CHECKED" && this.state.hideButton == false ? (
                                                <Popconfirm zIndex={1000000000} title="Are you sure？" onConfirm={(e:any) => {
                                                    this.deleteDocument()
                                                }} okText="Yes" cancelText="No">
                                                    <Button type="primary" danger style={{marginRight: 16}}
                                                            icon={<DeleteOutlined/>}
                                                    >
                                                        Delete
                                                    </Button>
                                                </Popconfirm>) : (<></>)
                                        }

                                    </div>
                                </div>

                            </div>
                        </div>

                    </Resizable>
                </Draggable>
            </Affix>


        </div>;
    }
}
